import * as S from "./PointHistoryList.style";
import { Point } from "@/common/types/point";
import { AlertText } from "@/components/atoms/AlertText";
import { PointHistoryItem } from "@/components/atoms/PointHistoryItem";

interface PointHistoryListProps {
  data: Point[];
}

export const PointHistoryList = ({ data }: PointHistoryListProps) => {
  return (
    <S.PointHistoryList>
      {data.map((item: Point, idx: number) => {
        return <PointHistoryItem data={item} key={idx} />;
      })}

      {!data && <AlertText subText="포인트 적립 내역이 없습니다." />}
    </S.PointHistoryList>
  );
};
